import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDeliveryOrderDataResponse = {
  value: string | null;
};

type QueryType = {
  marca: string;
  numero: string;
};

export const getDeliveryOrderContainerData = async (
  query: QueryType
): Promise<string | null> => {
  try {
    const res = await apiClient.post<GetDeliveryOrderDataResponse>(
      Endpoints.DeliveryOrder,
      query
    );
    return res.data.value || '';
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
